import {
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Icon,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useDisclosure,
  Link,
  FormControl,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  Divider,
  Progress,
  Button,
} from '@chakra-ui/react';
import { Link as RLink} from 'react-router-dom';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../store/state';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import { MdAccountCircle, MdSearch, MdShoppingCart } from 'react-icons/md';
import { BusinessItem, ItemsQuery } from '../../store/page/types';
import { fetchQueriedItems } from '../../store/page/initiators';
import { updateItemsQuery, getQueriedItemsSuccess } from '../../store/page/actions';
import { User } from '../../store/user/types';
import { Cart } from '../../store/cart/types';
import { Badge } from 'antd';

interface NavBarProps {
  isQuerying: boolean;
  queriedItems: BusinessItem[];
  itemsQuery: ItemsQuery;
  suppressSearchDisplay?: boolean;
  user: User | null;
  cart: Cart | null;
  fetchQueriedItems: (more: boolean) => void;
  updateItemsQuery: (update: ItemsQuery) => void;
  getQueriedItemsSuccess: (items: BusinessItem[]) => void;
}

const NavBar: React.FC<NavBarProps> = ({
  isQuerying, queriedItems, itemsQuery, suppressSearchDisplay, user, cart, fetchQueriedItems, updateItemsQuery, getQueriedItemsSuccess
}) => {
  const { isOpen, onToggle } = useDisclosure()
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);
  const isDesktop = window.innerWidth > 768;

  const debouncedSearch = (search: string) => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    const newTimer = setTimeout(() => {
      if (search.length > 2) {
        fetchQueriedItems(false);
      } else {
        updateItemsQuery({ ...itemsQuery, search });
      }
    }, 900);

    setDebounceTimer(newTimer)
  };

  const countCartQuantity = (cart: Cart): number => {
    let totalQuantity = 0;
  
    if (cart.items && cart.items.length > 0) {
      for (const item of cart.items) {
        totalQuantity += item.quantity;
      }
    }
  
    return totalQuantity;
  };

  return (
    <>
    <Box>
      <Flex
        bg={useColorModeValue('gray.800', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.500', 'gray.900')}
        align={'center'}>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }} alignItems={'center'}>
          {isDesktop 
          ?
          <Text
            fontFamily={'heading'}>
            <Link href='/'>
            <Image
              src={"/assets/images/showfa-logo.png"}
              alt="Showfa Logo"
              h="20px"
              w="auto"
            /> 
            </Link>
          </Text>
          :
          <>
          <Link href='/'>
            <Image
              src={"/assets/images/showfa-logo-mini.png"}
              alt="Showfa Logo"
              h="20px"
              w="auto"
            /> 
          </Link>
          {/* <IconButton
            onClick={onToggle}
            icon={isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />}
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          /> */}
          </>
          }
          <FormControl ml={2} mr={2}>
            <InputGroup>
              <InputLeftElement pointerEvents={'none'}>
                { isQuerying ? <Spinner size={'xs'}/> : <MdSearch />}
              </InputLeftElement>
              <Input 
                placeholder="Search Pages by Showfa Express"
                fontSize={'sm'}
                fontWeight={'bold'}
                onInput={() => console.log('input')} 
                value={itemsQuery.search}
                onChange={(e) => {
                  updateItemsQuery({ ...itemsQuery, search: e.target.value })
                  debouncedSearch(e.target.value)
                }}
                style={{ borderRadius: 25, backgroundColor: '#FFF', marginRight: 4, borderColor: 'black'}}
              />
            </InputGroup>
          </FormControl>  
          <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
          </Flex>
          { cart ?
          <RLink to={'/cart'}>
            <Flex 
            alignItems={'center'}
              pl={3} pr={3} pt={2} pb={2}
              _hover={{
                outline: '2px dotted #F7941D',
                borderRadius: '10px'
              }}
            > 
              <MdShoppingCart color={'white'} size={20}/>
              <Text ml={1} color='white' fontWeight={'bold'}>{countCartQuantity(cart)}</Text>
            </Flex>
          </RLink> :
          null}
          <RLink to={'/user'}>
          <Flex 
            flexDirection={'row'}
            alignItems={'center'}
            pl={3} pr={3} ml={2}
            _hover={{
              outline: '2px dotted #F7941D',
              borderRadius: '10px'
            }}
          >
            <Flex flexDirection={'column'} pr={2}>
              <Text fontSize={'xs'} textAlign={'right'} fontWeight={'bold'} color={'gray.200'}>Hello,</Text>
              <Text textAlign={'right'} fontWeight={'bold'} color={'gray.300'}>{user ? user.firstName : 'Login'}</Text>
            </Flex>
            <MdAccountCircle color={'#F7941D'} />
          </Flex>
          </RLink>

        </Flex>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
    {isQuerying ? <Progress size={'xs'} isIndeterminate colorScheme={'orange'}/> : null}
    {!suppressSearchDisplay && queriedItems && (
      <Stack spacing={4} mt={4} ml={4}>
        {queriedItems.slice(0,10).map((item) => (
          <>
          <RLink to={`/${item.pageKey}`} onClick={() => {
            updateItemsQuery({...itemsQuery, search: ''})
            getQueriedItemsSuccess([])

            }}>
          <Flex key={item._id} alignItems="center">
            <Image src={item.pageData?.media[0].url} alt={item.name} boxSize="50px" />
            <Box>
              <Text ml={2} color={'gray.600'}>{item.name}</Text>
              <Text ml={3} fontSize={'xs'}>#{item.pageKey}</Text>
            </Box>
            
          </Flex>
          </RLink>
          <Divider />
          </>
        ))}
      </Stack>
    )} 
    {!suppressSearchDisplay && !queriedItems.length && itemsQuery.search.length > 2 && (
      <Stack spacing={4} mt={4} ml={4}>
        <Flex alignItems="center" onClick={() => {
          updateItemsQuery({...itemsQuery, search: ''})
          getQueriedItemsSuccess([])
          }}>
          <Image src={'/assets/images/no-items-box.png'} alt={'nothing'} boxSize="50px" />
          <Box>
            <Text ml={2} color={'gray.600'}>Nothing found matching "{itemsQuery.search}"</Text>
          </Box>
        </Flex>
        <Divider />
      </Stack>      
    )}
    </>
  )
}

const DesktopNav = () => {
  const linkColor = useColorModeValue('gray.600', 'gray.200')
  const linkHoverColor = useColorModeValue('gray.800', 'white')
  const popoverContentBgColor = useColorModeValue('white', 'gray.800')

  return (
    <Stack direction={'row'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Box
                as="a"
                p={2}
                href={navItem.href ?? '#'}
                fontSize={'sm'}
                fontWeight={500}
                color={linkColor}
                _hover={{
                  textDecoration: 'none',
                  color: linkHoverColor,
                }}>
                {navItem.label}
              </Box>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  )
}

const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
  return (
    <Box
      as="a"
      href={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            transition={'all .3s ease'}
            _groupHover={{ color: 'pink.400' }}
            fontWeight={500}>
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}>
          <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Box>
  )
}

const MobileNav = () => {
  return (
    <Stack bg={useColorModeValue('white', 'gray.800')} p={4} display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  )
}

const MobileNavItem = ({ label, children, href }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Box
        py={2}
        as="a"
        href={href ?? '#'}
        justifyContent="space-between"
        alignItems="center"
        _hover={{
          textDecoration: 'none',
        }}>
        <Text fontWeight={600} color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Box>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Box as="a" key={child.label} py={2} href={child.href}>
                {child.label}
              </Box>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  )
}

interface NavItem {
  label: string
  subLabel?: string
  children?: Array<NavItem>
  href?: string
}

const NAV_ITEMS: Array<NavItem> = [];


const mapStateToProps = (state: ReduxState) => {
  const { isQuerying, itemsQuery,queriedItems } = state.page;
  const { user } = state.user;
  const { cart } = state.cart;
  return { isQuerying, itemsQuery,queriedItems, user, cart };
};

export default connect(mapStateToProps, {
  fetchQueriedItems,
  updateItemsQuery,
  getQueriedItemsSuccess
})(NavBar);
